import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ICadastroEmployee } from 'src/app/pages/employee/employee/models/employee';
import { EOrdenacao } from 'src/app/shared/data/ordenacao.enum';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';

@Component({
  selector: 'app-tab-colaboradores',
  templateUrl: './tab-colaboradores.component.html',
  styleUrls: ['./tab-colaboradores.component.scss']
})
export class TabColaboradoresComponent {
  ERoleAdminString = ERoleAdminString;
  @Input() dadosPaginacaoColaborador = {
    ordenacao: EOrdenacao.AlfabeticaAZ,
    paginaSelecionada: 0,
    tamanhoPagina: 4,
    totalPaginas: 0,
    itensTotal: 0
  };
  @Input() employers: ICadastroEmployee[] = [];
  @Input() companyId?: string;

  @Output() mudouPagina = new EventEmitter();
  @Output() mudouTamanhoPagina = new EventEmitter();
  @Output() recarregarListagem = new EventEmitter();

  constructor(private readonly router: Router) { }

  public abrirEmNovaAba(colaboradorId: string): void {
    const url = this.router.serializeUrl(this.router.createUrlTree([`/dash/colaboradores/editar/${colaboradorId}`]));

    window.open(url, '_blank');
  }
}
